'use client'

import useBreakpoint from '@/hooks/use-breakpoint'
import { onTransactionOpen } from '@/store'
import { useTranslations } from 'next-intl'

import WalletIcon from '@/components/icons/wallet'
import Button from '@/components/ui/button'
import { IconButton } from '@/components/ui/icon-button'
import { useWalletModal } from '@/components/wallet/use-wallet-modal'
import { Flex } from '@/styled-system/jsx'
import UserBalance from './header-user-balance'

export default function HeaderDeposit() {
  const isXl = useBreakpoint('xl')
  const isMd = useBreakpoint('md')
  const t = useTranslations('header')
  const { onOpen } = useWalletModal()

  return (
    <Flex align='center' h='11' onClick={!isMd ? onTransactionOpen : undefined}>
      <Flex
        align='center'
        justify='center'
        bgColor='pigmo.50'
        border='1px solid'
        borderColor='#271D2B'
        borderRight='none'
        borderRadius='lg'
        //borderRightRadius={0}
        p={3}
        h='full'
      >
        <UserBalance />
      </Flex>

      {isXl ? (
        <Button
          variant='secondary'
          size='md'
          borderRadius='lg'
          fontSize='xs'
          //boxShadow='0px 0px 60px 0px rgba(233, 0, 131, 0.25)'
          //borderLeftRadius={0}
          marginLeft={3}
          h='full'
          w='108px'
          onClick={() => onOpen()}
        >
          {t('deposit.trigger')}
        </Button>
      ) : (
        <IconButton
          variant='secondary'
          //bg='radial-gradient(50.92% 50% at 50% 100%, rgba(255, 255, 255, 0.60) 0%, rgba(117, 70, 96, 0.00) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%), linear-gradient(125deg, #E90083 0%, #FF6864 100%)'

          borderRadius='lg'
          //borderLeftRadius={0}
          //boxShadow='0px 0px 30px 0px rgba(233, 0, 131, 0.10)'
          h='11'
          w='11'
          onClick={() => onOpen()}
          marginLeft={2}
        >
          <WalletIcon />
        </IconButton>
      )}
    </Flex>
  )
}
